import { IDataFrameSchema } from '@/lib/dataFrameTypes';
import { uniqWith, isEqual } from 'lodash-es';
import { TEvaluationModel } from '@/lib/evaluationModelsApi';

const promptPlaceholder = `Enter a prompt to evaluate the data.\nUsing handlebars format {FIELD_NAME} to specify fields to interpretin the request.`;

const getModelCapabilities = (model: TEvaluationModel) => {
  return model.capabilities.input.flatMap((inputModality) =>
    model.capabilities.output.map((outputModality) => [inputModality, outputModality]),
  );
};

const getTypeOptions = (availableModels: TEvaluationModel[]) => {
  const allCapabilities = uniqWith(availableModels.flatMap(getModelCapabilities), isEqual);

  const typeOptions = allCapabilities.map(([inputType, outputType]) => ({
    value: `${inputType}|${outputType}`,
    label: `${inputType} → ${outputType}`,
  }));

  return typeOptions;
};

const defaultValues = {
  model: 'gpt-4o',
  type: 'text',
  sample_count: 5,
  target_column: 'prediction',
  name: '',
  prompt: '',
  target_branch: '',
  target_path: '',
  auto_commit: true,
  commit_message: '',
};

const extractValuesInCurlyBraces = (str: string = ''): string[] => {
  return str.match(/\{([^}]+)\}/g)?.map((match) => match.slice(1, -1)) || [];
};

const getErrorMessages = ({
  extractedFields,
  targetColumn,
  type,
  schema,
}: {
  extractedFields: string[];
  type: string;
  targetColumn: string;
  schema: IDataFrameSchema;
}) => {
  const issues = [];
  // does extratced fields contain any fields that are not in the schema
  const missingFields = extractedFields.filter((field) => !schema.fields.some((f) => f.name === field));
  if (missingFields.length > 0 && type === 'text') {
    issues.push('Prompt contains fields that are not in the schema.');
  }

  if (extractedFields.length < 1 && type === 'text') {
    issues.push('Prompt does not contain any fields.');
  }

  if (extractedFields.includes(targetColumn)) {
    issues.push('Output field should not overwrite a field in the prompt.');
  }

  return issues;
};

export { getTypeOptions, promptPlaceholder, extractValuesInCurlyBraces, getErrorMessages };
